import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { FetchPerformanceProfilePersonalReviews, FetchPerformanceProfilePersonalReviewsSuccess } from 'app/library/performance-profile-personal-review/actions';
import { PerformanceProfilePersonalReview } from 'app/library/performance-profile-personal-review/models/performance-profile-personal-review.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, take } from 'rxjs/operators';

export class PreformanceProfilePersonalReviewsDataSource implements DataSource<PerformanceProfilePersonalReview> {
    private _loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this._loadingSubject.asObservable();

    constructor(private _filteredPerformanceProfilePersonalReviews$: Observable<PerformanceProfilePersonalReview[]>, private _store: Store, private _action$: Actions) {}

    connect(collectionViewer: CollectionViewer): Observable<PerformanceProfilePersonalReview[]> {
        return this._filteredPerformanceProfilePersonalReviews$;
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this._loadingSubject.complete();
    }

    loadPerformanceProfilePersonalReviews(userId: string, pageSize?: number, pageNumber?: number): void {
        this._loadingSubject.next(true);

        this._store.dispatch(
            new FetchPerformanceProfilePersonalReviews({
                userId,
                pageSize,
                pageNumber,
            })
        );
        this._action$
            .pipe(
                ofActionDispatched(FetchPerformanceProfilePersonalReviewsSuccess),
                finalize(() => this._loadingSubject.next(false)),
                take(1)
            )
            .subscribe();
    }
}
